/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Empty_DescInputs */

const en_interview_empty_desc = /** @type {(inputs: Interview_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview prep generates questions based on your tracked jobs. Add a job first to get started with practice questions.`)
};

const de_interview_empty_desc = /** @type {(inputs: Interview_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Interview-Vorbereitung erstellt Fragen basierend auf deinen getrackten Jobs. Fuege zuerst einen Job hinzu.`)
};

const fr_interview_empty_desc = /** @type {(inputs: Interview_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La preparation d'entretien genere des questions basees sur vos emplois suivis. Ajoutez d'abord un emploi pour commencer.`)
};

const es_interview_empty_desc = /** @type {(inputs: Interview_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La preparacion de entrevistas genera preguntas basadas en tus empleos registrados. Anade un empleo primero para comenzar.`)
};

const it_interview_empty_desc = /** @type {(inputs: Interview_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La preparazione al colloquio genera domande basate sui lavori monitorati. Aggiungi prima un lavoro per iniziare.`)
};

const nl_interview_empty_desc = /** @type {(inputs: Interview_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollicitatietraining genereert vragen op basis van je gevolgde banen. Voeg eerst een baan toe om te beginnen.`)
};

const pl_interview_empty_desc = /** @type {(inputs: Interview_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przygotowanie do rozmowy kwalifikacyjnej generuje pytania na podstawie sledzonych ofert pracy. Najpierw dodaj oferte, aby zaczac.`)
};

const fi_interview_empty_desc = /** @type {(inputs: Interview_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haastatteluvalmistautuminen luo kysymyksiä seuraamiesi työpaikkojen perusteella. Lisää ensin työpaikka aloittaaksesi.`)
};

const da_interview_empty_desc = /** @type {(inputs: Interview_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interviewforberedelse genererer sporgsmol baseret pa dine sporede jobs. Tilföj forst et job for at komme i gang.`)
};

const sv_interview_empty_desc = /** @type {(inputs: Interview_Empty_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervjuforbedering genererar fragor baserat pa dina foljda jobb. Lagg till ett jobb forst for att borja.`)
};

/**
* | output |
* | --- |
* | "Interview prep generates questions based on your tracked jobs. Add a job first to get started with practice questions." |
*
* @param {Interview_Empty_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_empty_desc = /** @type {((inputs?: Interview_Empty_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Empty_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_empty_desc(inputs)
	if (locale === "fr") return fr_interview_empty_desc(inputs)
	if (locale === "es") return es_interview_empty_desc(inputs)
	if (locale === "it") return it_interview_empty_desc(inputs)
	if (locale === "nl") return nl_interview_empty_desc(inputs)
	if (locale === "pl") return pl_interview_empty_desc(inputs)
	if (locale === "fi") return fi_interview_empty_desc(inputs)
	if (locale === "da") return da_interview_empty_desc(inputs)
	if (locale === "sv") return sv_interview_empty_desc(inputs)
	return en_interview_empty_desc(inputs)
});